module.exports = __webpack_public_path__ + "img/about.ed8ed7cb.svg";